/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Accommodation } from '../models/Accommodation';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccommodationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves the collection of Accommodation resources.
     * Returns a Hydra Collection even for application/json.
     * @param limit
     * @param page The collection page number
     * @param adults
     * @param amenity one or more amenities
     * @param amenityGroup one or more amenity groups
     * @param bookableOnline
     * @param bookingOptions
     * @param category one or more accommodation categories
     * @param children
     * @param childrenAge
     * @param dateFrom
     * @param dateTo
     * @param onlyActive
     * @param provision
     * @param rating
     * @param region
     * @param voivodeship
     * @param latitude
     * @param longitude
     * @param country Country ID from NOP
     * @param radius Radius to search withing coordinates in meters
     * @param order Listing order, e.g. `order[price]=asc`
     * @param city
     * @param nocCountry Country ID from Noc
     * @param flexibleDays
     * @param noPrice
     * @param cms
     * @param cmsFieldPath
     * @param cmsDocumentId
     * @param poi POI ID to search accommodations around
     * @param priceFrom
     * @param priceTo
     * @param beachDistance Filter accommodations by maximum distance from the beach (in meters).
     * @param tags One or more accommodation tags (comma-separated).
     * @returns any Accommodation collection
     * @throws ApiError
     */
    public accommodationForListing(
        limit?: number,
        page: number = 1,
        adults?: number,
        amenity?: Array<
            | 'Unknown'
            | 'AMaximumOfTwoPetsAllowed'
            | 'ASteepStaircaseLeadsUpstairs'
            | 'AccessFromCorridor'
            | 'ActiveCard'
            | 'AdultFriendly'
            | 'AdventureParkNearby'
            | 'Aerobics'
            | 'AerobicsNearby'
            | 'AirConditioning'
            | 'AirPump'
            | 'Airport'
            | 'AirportNearby'
            | 'AirportTransfer'
            | 'AllInclusive'
            | 'AllianzCancellationInsurance'
            | 'AlpbachtalSeenlandCard'
            | 'AlpenthermeEhrenbergTicket2HoursDay'
            | 'AnimationPrograms'
            | 'Aquapark'
            | 'AquaparkNearby'
            | 'ArcadeGameRoom'
            | 'Archery'
            | 'AromaCabin'
            | 'AromaChamber'
            | 'ArrangementOfBeds'
            | 'ArrivalAfter20_00Oclock'
            | 'ArrivalAfterMidnight'
            | 'BabyBath'
            | 'BabyBathPlugProtector'
            | 'BabyBathTub'
            | 'BabyCot'
            | 'BabyCotAndHighChair'
            | 'BabyCotCanBePutIn'
            | 'BabyCotPayable'
            | 'BabyCotUpTo1_5Years'
            | 'BabyCotUpTo2Years'
            | 'BabyCotUpTo2YearsAndHighChair'
            | 'BabyCotUpTo3Years'
            | 'BabyFeedingSet'
            | 'BabyFoodAndDrink'
            | 'BabyFoodHeatingOption'
            | 'BabyPool'
            | 'BabySupervision'
            | 'BabySupervisorPhone'
            | 'BabyToys'
            | 'BadmintonNearby'
            | 'Balcony'
            | 'BalconyTerrace'
            | 'BallGames'
            | 'Bar'
            | 'BarByThePool'
            | 'BarNearby'
            | 'Barbecue'
            | 'BarrierFree'
            | 'BarrierFreeForWheelchairs'
            | 'BarrierFreeParking'
            | 'BarrierFreeRoom'
            | 'Basketball'
            | 'Bath'
            | 'BathNearby'
            | 'Bathrobe'
            | 'BathroomToiletries'
            | 'Bathtub'
            | 'BeachBar'
            | 'BeachFootball'
            | 'BeachTowel'
            | 'BeachTransfer'
            | 'BeachVolleyball'
            | 'BeautyParlour'
            | 'BedLinenIsNotProvided'
            | 'BedSheets'
            | 'BedSheetsAndTowels'
            | 'BedsReadyUponArrival'
            | 'Bicycle'
            | 'BicyclePathNearby'
            | 'BicycleTouringRouteNearby'
            | 'Bidet'
            | 'BigCapacityHouse'
            | 'BikeRental'
            | 'BikeRentalAtTheAccommodation'
            | 'BikeRentalNearTheAccommodation'
            | 'Billiard'
            | 'BilliardsAndTableTennis'
            | 'BioSauna'
            | 'BoatRental'
            | 'BoatRentalNearby'
            | 'Bobsled'
            | 'Books'
            | 'BoosterSeatForChildren'
            | 'BottledWater'
            | 'Bowling'
            | 'Breakfast'
            | 'BreakfastHotAndColdBuffet'
            | 'BreathingMonitor'
            | 'Buggy'
            | 'BungeeJumping'
            | 'BusAndTruckParkingLot'
            | 'BusStop'
            | 'BusStopNearby'
            | 'BusinessCenter'
            | 'CDDVDPlayer'
            | 'CDPlayer'
            | 'CableTV'
            | 'CableTVWithGermanAndScandinavianChannels'
            | 'CableTVWithGermanChannels'
            | 'CafNearby'
            | 'Cafe'
            | 'CarRental'
            | 'CarRentalNearby'
            | 'CarbonMonoxideDetector'
            | 'CashNotAccepted'
            | 'Casino'
            | 'CateringServices'
            | 'CateringServicesOptionA'
            | 'CateringServicesOptionB'
            | 'CateringServicesOptionC'
            | 'CateringServicesOptionD'
            | 'CateringServicesOptionE'
            | 'CeilingFan'
            | 'CentralHeating'
            | 'ChangingTable'
            | 'ChildAnimationPrograms'
            | 'ChildBedding'
            | 'ChildBike'
            | 'ChildMenu'
            | 'ChildSlide'
            | 'ChildStepUpStool'
            | 'ChildSupervision'
            | 'ChildrensBedUpTo12Years'
            | 'ChildrensBikeRental'
            | 'ChildrensClub'
            | 'ChildrensPool'
            | 'Chinese'
            | 'Cinema'
            | 'CinemaNearby'
            | 'CitySightseeingFlight'
            | 'Cleaning'
            | 'CleaningDuringStay'
            | 'CleaningOnlyOnWeekdays'
            | 'CleaningOnlyOnWeekends'
            | 'CleaningToolsProducts'
            | 'ClosestGroceryStore'
            | 'ClubCard'
            | 'ClubInnsbruckMemberCard'
            | 'CoffeeGrinder'
            | 'CoffeeMaker'
            | 'CoffeeTeaSet'
            | 'Computer'
            | 'ConferenceRoom'
            | 'ConnectorCover'
            | 'ConstructionNearby'
            | 'Cooker'
            | 'CookingInCauldron'
            | 'CookingOnGrillDisc'
            | 'Cookware'
            | 'CornerProtectorForFurnitures'
            | 'Couch'
            | 'Courtyard'
            | 'Cruise'
            | 'Curling'
            | 'CurlingFacilityNearby'
            | 'Curtain'
            | 'DVDPlayer'
            | 'DVDRental'
            | 'DVDRentalNearby'
            | 'DailyCleaning'
            | 'Darts'
            | 'DartsNearby'
            | 'DeckChair'
            | 'Dehumidifier'
            | 'DeskInTheRoom'
            | 'DialUpInternetAccess'
            | 'DietaryMenu'
            | 'DigitalTVService'
            | 'DirectAccessToSkiSlopes'
            | 'DirectSkiTrailAccess'
            | 'DisabledParking'
            | 'Disco'
            | 'DiscoNearby'
            | 'DiscoNearbyTheAccommodation'
            | 'Dishtowels'
            | 'Dishwasher'
            | 'Dryer'
            | 'DryingRack'
            | 'EgyptianCottonSheets'
            | 'ElectricCarChargingOption'
            | 'ElectricCarChargingStation'
            | 'ElectricCookerWithOven'
            | 'ElectricCookerWithSmallOven'
            | 'ElectricHeating'
            | 'ElectricHotPlate'
            | 'ElectricStove'
            | 'Electricity'
            | 'Elevator'
            | 'EnergyCost'
            | 'EnergySupply220V'
            | 'EnglishSpeakingStaff'
            | 'EnvironmentalTax'
            | 'EspressoMachine'
            | 'EventsAndPartiesAreNotPermitted'
            | 'ExchangeOffice'
            | 'ExchangeOfficeNearby'
            | 'ExpressCheckIn'
            | 'ExpressCheckOut'
            | 'ExternalEntranceToTheBedroom'
            | 'ExtraBed'
            | 'ExtraBeds'
            | 'ExtraFoldingBedsPayable'
            | 'ExtraRoomFor1PersonXROM'
            | 'ExtraRoomFor2Persons'
            | 'ExtraTowel'
            | 'FarmhouseStyleBuilding'
            | 'FencedProperty'
            | 'FerryPortTransfer'
            | 'Films'
            | 'FinalCleaning'
            | 'FinalCleaningAndBedSheetsInCaseOfAStayOfLessThan6Nights'
            | 'FinalCleaningIsNotIncludedInThePrice'
            | 'FinnishSauna'
            | 'FirePit'
            | 'Fireplace'
            | 'FirewoodCanBePurchased'
            | 'FirstAndSecondFloor'
            | 'FirstFloor'
            | 'FishPedicure'
            | 'Fishing'
            | 'FishingAtTheAccommodation'
            | 'FishingHouseStyleBuilding'
            | 'FishingNearTheAccommodation'
            | 'Fitness'
            | 'FoodBasket'
            | 'FoodDeliveryToTheAreaOnSpecifiedDays'
            | 'Football'
            | 'FreeDrivewayOnTheProperty'
            | 'FreeFirewood'
            | 'FreeGarageOnTheProperty'
            | 'FreeLocalPhoneCallsLimited'
            | 'FreeNewspapersInTheLobbyOnWeekdays'
            | 'FreeParking5MinutesAway'
            | 'FreeParkingNearby'
            | 'FreePrivateParking'
            | 'FreeSkiCoursesSkiRentalAndSkiTicketsForChildrenBornSince2009'
            | 'FreeSlideParkEntry'
            | 'FreeThermalSpaTicket'
            | 'FreeToiletries'
            | 'FreeTransferFromTrainStation'
            | 'FreeTransferToTrainStation'
            | 'FreeUsageOfLocalIndoorAndOutdoorPools'
            | 'FreeWiFiLimitedUse'
            | 'Freezer'
            | 'FreezerShelf'
            | 'French'
            | 'Fridge'
            | 'Games'
            | 'Garage'
            | 'Garage1x'
            | 'Garage1xUponRequest'
            | 'Garage2x'
            | 'GarageUponRequest'
            | 'Garden'
            | 'GardenFurniture'
            | 'Gas'
            | 'GasConvector'
            | 'GasHeating'
            | 'GasOrElectricStove'
            | 'GasPoweredFridge'
            | 'Gazebo'
            | 'GeothermalHeating'
            | 'Geyser'
            | 'GlutenFreeDiet'
            | 'GolfCourse'
            | 'GolfSimulator'
            | 'GolfSimulatorNearby'
            | 'GolfTeachingOnSite'
            | 'Griddle'
            | 'GrillingOptionPayable'
            | 'GroceryStore'
            | 'GroundFloor'
            | 'GuestCardCitiziensPassportCard'
            | 'GuestCardGC1'
            | 'GymSportHall'
            | 'GymSportHallNearby'
            | 'HDTV'
            | 'HOTELDETesztSzolg'
            | 'HairDryerOnRequestPayable'
            | 'HairdresserBeautySalon'
            | 'HairdresserBeautySalonNearby'
            | 'HairdressersParlour'
            | 'HairdressersWithFreeHaircut'
            | 'Hairdryer'
            | 'HalfBoard'
            | 'Handcart'
            | 'Hangers'
            | 'HaySauna'
            | 'HealthCenter'
            | 'HealthCenterNearby'
            | 'Heating'
            | 'HerbalSauna'
            | 'HighChair'
            | 'HighChairBabCotAndBabyBath'
            | 'Hiking'
            | 'HikingOpportunities'
            | 'HorseRiding'
            | 'HorseRidingAtTheAccommodation'
            | 'HorseRidingSchool15KmAway'
            | 'HorseRidingSchool5KmAway'
            | 'HotAirBalloon'
            | 'HotAirBalloonNearby'
            | 'HotPlate'
            | 'HotTub'
            | 'HotelAerobics'
            | 'HotelAerobicsNearby'
            | 'HotelBubbleBath'
            | 'HotelDarts'
            | 'HotelDisco'
            | 'HotelGardenNearby'
            | 'HotelHotTubNearby'
            | 'HotelHotelTransportation'
            | 'HouseMadeOfReinforcedConcrete'
            | 'HouseMadeOfWoodAndBrick'
            | 'HuluAccess'
            | 'Humidifier'
            | 'Hungarian'
            | 'Hunting'
            | 'HuntingNearTheAccommodation'
            | 'HurghadaElGounaOneWayTransfer'
            | 'HydroMassageShowerHead'
            | 'HypoallergenicBedding'
            | 'IPad'
            | 'IPodDockingStation'
            | 'IWouldLikeToReceiveInformationAboutAirportTransfer'
            | 'IWouldLikeToReceiveInformationAboutSkiPassDiscounts'
            | 'IWouldLikeToReceiveInformationAboutTheFoodBasket'
            | 'IceCave'
            | 'IceMaker'
            | 'IceSauna'
            | 'IceShower'
            | 'IceSkatingNearby'
            | 'InCaseOfAStayLongerThan6DaysTheFinalCleaningIsIncludedInThePrice'
            | 'InCaseOfAStayOfAtLeast6DaysTheFirstSetOfBedSheetsAndTowelsAreProvided'
            | 'Indian'
            | 'IndoorPaddlingPool'
            | 'IndoorPool'
            | 'IndoorPoolHeated'
            | 'IndoorPoolPayable'
            | 'IndoorSaltwaterPoolHeated'
            | 'IndoorSwimmingPoolNearby'
            | 'IndoorSwimmingPoolTicket'
            | 'IndoorTennisCourt'
            | 'IndoorTennisCourtNearby'
            | 'InformationServices'
            | 'InfraSauna'
            | 'InnsbruckCard'
            | 'InternetAccess'
            | 'InternetCaf'
            | 'InternetCafNearby'
            | 'InternetConnection'
            | 'InternetCorner'
            | 'InternetInPublicAreas'
            | 'IronAndIroningBoard'
            | 'IronAndIroningBoardOnRequest'
            | 'IronAndIroningBoardOnRequestPayable'
            | 'IroningAvailable'
            | 'IroningBoard'
            | 'ItCanBeRentedOnlyForVacation'
            | 'Italian'
            | 'Jacuzzi'
            | 'JacuzziBench'
            | 'JacuzziNearby'
            | 'JacuzziPayable'
            | 'JadeMassageBed'
            | 'JetPool'
            | 'KaiserwinklCard'
            | 'KaraokeEquipment'
            | 'Kettle'
            | 'KeyAcquisitionFee'
            | 'KeyAqusitionService'
            | 'KidsPoolHeated'
            | 'Kitchen'
            | 'KitchenUtensils'
            | 'KitchenWithColdWater'
            | 'KitchenWithHotAndColdWater'
            | 'KitchenWithWellWater'
            | 'Kitchenette'
            | 'KitchenetteWithHotAndColdWater'
            | 'KneippCircuit'
            | 'KosherFood'
            | 'LCDTV'
            | 'LEDTV'
            | 'LEGOLAND2DayTicketConsecutiveDays'
            | 'LEGOLANDBreakfast'
            | 'LactoseFreeDiet'
            | 'LateCheckIn20_00To08_00'
            | 'Laundry'
            | 'LaundryPayable'
            | 'LectureHall'
            | 'LeisurePool'
            | 'Library'
            | 'LimitedHotWater'
            | 'LimitedWiFiPayable'
            | 'LimousineOrCarRenting'
            | 'LimousineOrdering'
            | 'Lobby'
            | 'LobbyBarNearby'
            | 'LocalSpecialties'
            | 'LocalTax'
            | 'LocalTaxForChildren'
            | 'LocalTaxForChildren0To2Years'
            | 'LocalTaxForChildren12To15Years'
            | 'LocalTaxForChildren12To17'
            | 'LocalTaxForChildren3To11Years'
            | 'LocalTaxForChildren3To12Years'
            | 'LocalTaxForChildren3To17Years'
            | 'LocalTaxForChildren3To18Years'
            | 'LocalTaxForChildren3To5Years'
            | 'LocalTaxForChildren6To16Years'
            | 'LocatedNearAMainRoad'
            | 'LocatedOnDifferentLevels'
            | 'LockableCloset'
            | 'LongTermParkingPayable'
            | 'LowCarbDiet'
            | 'LowCeilingHeight'
            | 'LowCholesterolDiet'
            | 'LuggageRoom'
            | 'LuxPackage'
            | 'LyingMassage'
            | 'MP3Dock'
            | 'Manicure'
            | 'Massage'
            | 'MassageBench'
            | 'MassageInTheRoom'
            | 'MassageNearby'
            | 'MassageNozzle'
            | 'MassageSeats'
            | 'MedicalRoom'
            | 'MedicinalPool'
            | 'Mediterranean'
            | 'MemoryFoamMattress'
            | 'Mexican'
            | 'MicrowaveOven'
            | 'MiniBar'
            | 'MiniFridge'
            | 'Minigolf'
            | 'Minigrill'
            | 'Mixer'
            | 'MobileBabyCot'
            | 'MobileHome'
            | 'Modern'
            | 'MonkeyBars'
            | 'MotorboatRental'
            | 'MountainClimbing'
            | 'MountainClimbingNearby'
            | 'MudBath'
            | 'MultilingualStaff'
            | 'MurtalCard'
            | 'MushroomPicking'
            | 'MusicLibrary'
            | 'N10000LiterWaterTank'
            | 'N10PercentDiscountAtSportHervisSt_Anton'
            | 'N10PercentDiscountOnSwarovskiCrystalWorldsTickets'
            | 'N13KgWood'
            | 'N15KgWood'
            | 'N1SetOfBeachTowels'
            | 'N1UmbrellaAnd2SunbedsPerApartment'
            | 'N1XSaunaUsage'
            | 'N20000LiterWaterTank'
            | 'N20KgWood'
            | 'N24hHealthClub'
            | 'N24hPoolUse'
            | 'N2HoursOfSaunaUsage'
            | 'N2SetsOfWood'
            | 'N2XParkingSpace'
            | 'N2XWiFiAccess'
            | 'N30000LiterWaterTank'
            | 'N3FunctionGameTable'
            | 'N40000LiterWaterTank'
            | 'N50000LiterWaterTank'
            | 'N6DayAquaSpaPassAbove16Years'
            | 'N6DaySwimmingPoolTicketForChildren3To15Years'
            | 'NappyDryer'
            | 'NaturSauna'
            | 'NaturalArea'
            | 'NaturalGasHeating'
            | 'NearestRestaurant'
            | 'NeckShower'
            | 'Netflix'
            | 'NetflixAccess'
            | 'Newspaper'
            | 'NewspapersInTheLobbyPayable'
            | 'Nightclub'
            | 'NoBabyCot'
            | 'NoBedLinen'
            | 'NoCleaning'
            | 'NoDoorOnTheBedroom'
            | 'NoElevator'
            | 'NoHeating'
            | 'NoHotWater'
            | 'NoInsulationInTheHouse'
            | 'NoTowel'
            | 'NonDrinkingWater'
            | 'NonSmoking'
            | 'NonSmokingArea'
            | 'NotAvailableForSchools'
            | 'NotSuitableForYoungGroups'
            | 'NursingPillow'
            | 'OfficeRental'
            | 'Oil'
            | 'OilFueledPowerGenerator12V'
            | 'OilFueledPowerGenerator220V'
            | 'OilHeating'
            | 'OilRadiator'
            | 'OnSiteParking'
            | 'OnePersonSofa'
            | 'OneSkiPass'
            | 'OneTimeCleaningDuringStay'
            | 'OnlyDogsAllowed'
            | 'OnlyDogsAndCatsAllowed'
            | 'OnlyServiceAnimalsAllowed'
            | 'OnlyWomenAllowed'
            | 'OpenFireplaceAvailable'
            | 'OpenProperty'
            | 'OpeningBlockerForFenestration'
            | 'OpeningBlockerForFurniture'
            | 'OrganizedSightseeing'
            | 'OrganizedSightseeingNearby'
            | 'OrganizedTrip'
            | 'OrganizingCruises'
            | 'OrganizingCulturalAndSportingEvents'
            | 'OutdoorActivities'
            | 'OutdoorFireplace'
            | 'OutdoorFishCleaningPlace'
            | 'OutdoorPaddlingPool'
            | 'OutdoorPool'
            | 'OutdoorPoolHeated'
            | 'OutdoorPoolNearby'
            | 'OutdoorSauna'
            | 'OutdoorSeasonalPool'
            | 'OutdoorSeasonalPoolHeated'
            | 'OutdoorSlide'
            | 'OutdoorSwimmingPoolNearby'
            | 'OutdoorTennisCourt'
            | 'OutdoorTennisCourtNearby'
            | 'OutdoorWaterTank'
            | 'Oven'
            | 'OwnJacuzzi'
            | 'OwnPool'
            | 'OwnRestaurant'
            | 'PURIAPremiumSpaPE'
            | 'PaleoDiet'
            | 'PanoramicViewToTheLandscape'
            | 'PanoramicViewToTheMountains'
            | 'PanoramicViewToTheWaters'
            | 'PaperTowel'
            | 'Paragliding'
            | 'Park'
            | 'ParkNearby'
            | 'Parking'
            | 'ParkingInTheStreet'
            | 'ParkingNearby'
            | 'ParkingNearbyMustBeBookedInAdvance'
            | 'ParkingPlace'
            | 'ParkingService'
            | 'ParkingServicePayable'
            | 'ParkingSpaceCenterValClaretLavachet'
            | 'ParkingSpaceUponPriorRequest'
            | 'ParkingSpaceValThorensP0P1P25To7Nights'
            | 'PartiallyInsulated'
            | 'PastryShop'
            | 'PastryShopNearby'
            | 'Patio'
            | 'PayableParkingGarageNearby'
            | 'PedaloRental'
            | 'Pedicure'
            | 'PelletStove'
            | 'PetFriendly'
            | 'PetsAndServiceAnimalsNotAllowed'
            | 'PetsAreAllowed'
            | 'Phone'
            | 'PicnicArea'
            | 'Pizzeria'
            | 'PizzeriaNearby'
            | 'PlaneTicketReservation'
            | 'PlasmaTV'
            | 'PlayCarpet'
            | 'Playground'
            | 'PlaygroundNearby'
            | 'Playhouse'
            | 'Playpen'
            | 'Playroom'
            | 'PlumbingSystem'
            | 'PlungePool'
            | 'PlungeTub'
            | 'Pool'
            | 'PoolHeating'
            | 'PoolHeatingUponRequestNoLaterThan7DaysBeforeArrival'
            | 'PoolTicket'
            | 'Pools'
            | 'PoolsideCabanas'
            | 'PoolsideCabanasPayable'
            | 'Port'
            | 'PortableRadiator'
            | 'Potty'
            | 'PremiumTVChannels'
            | 'PrivateBathroomOutsideTheRoom'
            | 'PrivateBeach'
            | 'PrivateBikeStorage'
            | 'PrivateHotTub'
            | 'PrivateParkingPayable'
            | 'PrivatePier'
            | 'PrivateYachtMarina'
            | 'Pub'
            | 'PubNearby'
            | 'PublicPool'
            | 'Radio'
            | 'RadioAndCDPlayer'
            | 'Reception'
            | 'ReformDiet'
            | 'RefrigeratorOnRequest'
            | 'RegistrationFee'
            | 'RelaxRoom'
            | 'RentSpaAndRelaxArea'
            | 'Restroom'
            | 'RobinsonStyleAccommodation'
            | 'RoofGarden'
            | 'RoomAccommodationType'
            | 'RoomAmenityRoomAmenityWasherDryerTrue'
            | 'RoomAtAnotherAddress'
            | 'RoomBedSize'
            | 'RoomBedTypes'
            | 'RoomNumberOfBedrooms'
            | 'RoomNumberOfRooms'
            | 'RoomOutlook'
            | 'RoomRoomSize'
            | 'RoomSafe'
            | 'RoomSafeLaptopSize'
            | 'RoomScenicView'
            | 'RoomService'
            | 'RoomServiceLimitedHours'
            | 'RoseSauna'
            | 'Rowhouse'
            | 'RunningTrackNearby'
            | 'SAMOCompleteprogram'
            | 'SUPRental'
            | 'SafeDepositBox'
            | 'Sailing'
            | 'SailingNearby'
            | 'SaltCave'
            | 'SaltCaveNearby'
            | 'SaltChamber'
            | 'SaltTherapy'
            | 'SalzburgCard'
            | 'Sandpit'
            | 'SatelliteDish'
            | 'SatelliteDishWithGermanChannels'
            | 'SatelliteTV'
            | 'Sauna'
            | 'SaunaAndPoolTicket'
            | 'SaunaAndSteamBathWithBathrobe'
            | 'SaunaNearby'
            | 'SaunaSeance'
            | 'SaunaWithEssentialOils'
            | 'Saunas'
            | 'SchladmingSommercard'
            | 'ScubaDiving'
            | 'ScubaDivingNearby'
            | 'SecludedProperty'
            | 'SecondAndThirdBabyCot'
            | 'SecondBathroom'
            | 'SecondFloor'
            | 'SecondSetOfBedSheets'
            | 'SecretarialServices'
            | 'SecurityDeposit'
            | 'Seesaw'
            | 'SemiBasement'
            | 'SemiDetachedHouse'
            | 'SeparateBathroom'
            | 'SeparateBedroom'
            | 'SeparateDiningRoom'
            | 'SeparateEntrance'
            | 'SeparateLivingRoom'
            | 'SeparateWorkspaceForLaptops'
            | 'ServicePaketPackage'
            | 'Shampoo'
            | 'SharedBathroom'
            | 'SharedBathroomWithWashbasinInTheRoom'
            | 'SharedFridge'
            | 'SharedGardenFurniture'
            | 'SharedIndoorPool'
            | 'SharedKitchen'
            | 'SharedSauna'
            | 'SharedSaunaPayable'
            | 'SharedUseProperty'
            | 'SharedWashingMachinePayable'
            | 'ShipRental'
            | 'ShootingRange'
            | 'ShootingRangeNearby'
            | 'ShoppingCenter'
            | 'ShoppingCenterNearby'
            | 'ShoppingService'
            | 'Shower'
            | 'SilvrettaCard'
            | 'SkiLift'
            | 'SkiLiftNearby'
            | 'SkiPassAvailable'
            | 'SkiPassFor6Or13Days'
            | 'SkiRental'
            | 'SkiRentalDiscount10Percent'
            | 'SkiRentalDiscount10PercentSportHarryStGallenkirch'
            | 'SkiRentalDiscount20PercentSportBruggerSlden'
            | 'SkiRentalDiscount20PercentSportHuberKappl'
            | 'SkiRentalNearby'
            | 'SkiStorage'
            | 'SkiStorageNearby'
            | 'SkiTrailTransfer'
            | 'Skiing'
            | 'Skittles'
            | 'SleepNumberBedWithSelectComfortMattress'
            | 'Slide'
            | 'SlidePark'
            | 'Slippers'
            | 'SmallTiledStove'
            | 'SmartTV'
            | 'SmokingAndNonSmokingRoom'
            | 'SmokingArea'
            | 'SmokingRoom'
            | 'SnackBar'
            | 'SnackBarNearby'
            | 'Soap'
            | 'SolarEnergy12V'
            | 'SolarEnergy220V'
            | 'Solarium'
            | 'SolariumNearby'
            | 'Soundproofing'
            | 'SpaTreatments'
            | 'SpecialDietMenu'
            | 'Spices'
            | 'SportsEquipmentRental'
            | 'SportsEquipmentRentalNearby'
            | 'SportsField'
            | 'Squash'
            | 'StablingOfOwnHorseIsPossible'
            | 'SteamChamber'
            | 'SteamRoom'
            | 'SteamRoomNearby'
            | 'StereoSystem'
            | 'StoneHouse'
            | 'StreamCanal'
            | 'StreamingServices'
            | 'Stroller'
            | 'SunbathingTerrace'
            | 'Sunshade'
            | 'Surfing'
            | 'SurfingNearby'
            | 'SwimmingInNature'
            | 'SwimmingInNatureNearby'
            | 'SwimmingPool'
            | 'Swing'
            | 'SwingAndSandpit'
            | 'TV'
            | 'TVCRT'
            | 'TVRoom'
            | 'Table'
            | 'TableTennis'
            | 'Tablet'
            | 'TauernSpa10PercentDiscount'
            | 'Taxi'
            | 'TeaCoffeeMaker'
            | 'TeaInstantCoffee'
            | 'Telephone'
            | 'Television'
            | 'TelevisionPayable'
            | 'TempurPedicMattress'
            | 'Tennis'
            | 'Tepidarium'
            | 'TepidariumNearby'
            | 'Terrace'
            | 'Thai'
            | 'TheBedroomIsAWalkThroughRoom'
            | 'TheDepositIsASecurityRetainerAndWillBeRefundedUponProperReturnOfTheRentalProperty'
            | 'TheFeesRestrictionsDontApplyToServiceAnimals'
            | 'TheFirstSetOfSheets'
            | 'TheFirstSetOfSheetsAndTowels'
            | 'TheFirstSetOfTowels'
            | 'TheOwnerLivesInTheBuilding'
            | 'TheOwnerLivesOnTheProperty'
            | 'Theatre'
            | 'TheatreNearby'
            | 'ThermalBathNearby'
            | 'ThermalPool'
            | 'Thermometer'
            | 'ThirdFloor'
            | 'TileStove'
            | 'Toaster'
            | 'TobogganingNearby'
            | 'Toilet'
            | 'ToiletInTheYard'
            | 'ToiletPaper'
            | 'ToiletSeat'
            | 'ToiletWithHotAndColdWater'
            | 'ToiletWithoutWashbasin'
            | 'Toiletries'
            | 'TourGuiding'
            | 'TowelAndBedclothesPayable'
            | 'Towels'
            | 'Traditional'
            | 'TrainStation'
            | 'TrainStationNearby'
            | 'TramStop'
            | 'TramStopNearby'
            | 'Trampoline'
            | 'TranquilityRoom'
            | 'TransferFromTrainStationPayable'
            | 'TransferToTrainStationPayable'
            | 'TurkishBathHamam'
            | 'TwoPersonSofa'
            | 'UnderfloorHeating'
            | 'UnderfloorHeatingInPart'
            | 'UnderfloorHeatingInTheBathroom'
            | 'UnderfloorHeatingInTheEntireHouse'
            | 'UnlimitedUsageOfOutdoorPoolFor6Days'
            | 'UsableUpTo2YearsOfAgeMaximumOf3YearsOfAge'
            | 'VacuumCleaner'
            | 'VeganDiet'
            | 'VegetarianDiet'
            | 'VendingMachine'
            | 'Ventilator'
            | 'VideoGame'
            | 'VideoGameConsole'
            | 'VideoGamePayable'
            | 'VideoGames'
            | 'VideoLibrary'
            | 'ViewToTheLake'
            | 'ViewToTheLandscape'
            | 'ViewToTheMountains'
            | 'ViewToTheSea'
            | 'ViewToTheWatersAndMountains'
            | 'Vineyard'
            | 'Volleyball'
            | 'VolleyballFacilityNearby'
            | 'WaistMassage'
            | 'Washbasin'
            | 'WashingMachine'
            | 'WashingMachineAndDryer'
            | 'WasserparkRussbach'
            | 'Water'
            | 'WaterDispenser'
            | 'WaterMushroom'
            | 'WaterSki'
            | 'WaterSkiingNearby'
            | 'WaterSupplyFromWaterTank'
            | 'WaterfrontLocation'
            | 'WeeklyChangeOfBedSheetsAndTowels'
            | 'WeeklyCleaning'
            | 'WeeklyRoomCleaning'
            | 'WelcomePackage'
            | 'WellnessSectionRelaxation'
            | 'WellnessSpaNearby'
            | 'WellnessTowel'
            | 'Wheelchair'
            | 'WiFi'
            | 'WiFiInPublicAreas'
            | 'WiFiMaximumOf5Devices1GBWeek'
            | 'WineBar'
            | 'WineBarNearby'
            | 'WineCellar'
            | 'WineCellarNearby'
            | 'Winterized'
            | 'WiredInternetConnection'
            | 'Wood'
            | 'WoodFramedBuilding'
            | 'WoodenHouse'
            | 'XboxRoom'
            | 'Yoga'
            | 'Shading'
        >,
        amenityGroup?: Array<
            | 'Internet'
            | 'Parking'
            | 'Catering'
            | 'Tv'
            | 'SwimmingPool'
            | 'Sauna'
            | 'Playground'
            | 'Bicycle'
            | 'CardPayment'
            | 'Pets'
            | 'Jacuzzi'
            | 'AirConditioning'
        >,
        bookableOnline?: 0 | 1,
        bookingOptions?: Array<'RealTime' | 'FreeCancel' | 'WithoutPrepayment'>,
        category?: Array<
            | 'Unknown'
            | 'Apartment'
            | 'Chalet'
            | 'Guesthouse'
            | 'HolidayHome'
            | 'Hostel'
            | 'Hotel'
            | 'Inn'
            | 'Lighthouse'
            | 'Motel'
            | 'Pension'
            | 'Resort'
            | 'RuralTourism'
            | 'Sanatorium'
            | 'StudentHostel'
            | 'Villa'
        >,
        children?: number,
        childrenAge?: Array<number>,
        dateFrom?: string,
        dateTo?: string,
        onlyActive?: 0 | 1,
        provision?: Array<
            | 'Unknown'
            | 'NoMeal'
            | 'Breakfast'
            | 'HalfBoard'
            | 'FullBoard'
            | 'AllInclusive'
            | 'SoftAllInclusive'
            | 'Lunch'
            | 'Dinner'
        >,
        rating?: number,
        region?: number,
        voivodeship?: number,
        latitude?: number,
        longitude?: number,
        country?: number,
        radius?: number,
        order?: Array<string>,
        city?: number,
        nocCountry?: number,
        flexibleDays?: number,
        noPrice?: 0 | 1,
        cms?: string,
        cmsFieldPath?: string,
        cmsDocumentId?: string,
        poi?: string,
        priceFrom?: number,
        priceTo?: number,
        beachDistance?: number,
        tags?: Array<'kitchen' | 'private-bathroom'>,
    ): CancelablePromise<{
        'hydra:member': Array<Accommodation>;
        'hydra:totalItems'?: number;
        'hydra:view'?: {
            '@id'?: string;
            '@type'?: string;
            'hydra:first'?: string;
            'hydra:last'?: string;
            'hydra:previous'?: string;
            'hydra:next'?: string;
        };
        'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:mapping'?: Array<{
                variable?: string;
                required?: boolean;
            }>;
        };
        'hydra:nopTotalItems'?: number;
        'hydra:realTimeItems'?: number;
        'hydra:partial'?: boolean;
        'hydra:strategy'?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing',
            query: {
                limit: limit,
                page: page,
                adults: adults,
                amenity: amenity,
                'amenity-group': amenityGroup,
                'bookable-online': bookableOnline,
                'booking-options': bookingOptions,
                category: category,
                children: children,
                'children-age': childrenAge,
                'date-from': dateFrom,
                'date-to': dateTo,
                'only-active': onlyActive,
                provision: provision,
                rating: rating,
                region: region,
                voivodeship: voivodeship,
                latitude: latitude,
                longitude: longitude,
                country: country,
                radius: radius,
                order: order,
                city: city,
                'noc-country': nocCountry,
                'flexible-days': flexibleDays,
                'no-price': noPrice,
                cms: cms,
                'cms-field-path': cmsFieldPath,
                'cms-document-id': cmsDocumentId,
                poi: poi,
                'price-from': priceFrom,
                'price-to': priceTo,
                beach_distance: beachDistance,
                tags: tags,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * @deprecated
     * Retrieves the collection of Accommodation resources (Deprecated).
     * This endpoint is deprecated. Use /accommodations/listing instead.
     * @param limit
     * @param page The collection page number
     * @param adults
     * @param amenity one or more amenities
     * @param amenityGroup one or more amenity groups
     * @param bookableOnline
     * @param bookingOptions
     * @param category one or more accommodation categories
     * @param children
     * @param childrenAge
     * @param dateFrom
     * @param dateTo
     * @param onlyActive
     * @param provision
     * @param rating
     * @param region
     * @param voivodeship
     * @param latitude
     * @param longitude
     * @param country Country ID from NOP
     * @param radius Radius to search withing coordinates in meters
     * @param order Listing order, e.g. `order[price]=asc`
     * @param city
     * @param nocCountry Country ID from Noc
     * @param flexibleDays
     * @param noPrice
     * @param cms
     * @param cmsFieldPath
     * @param cmsDocumentId
     * @param poi POI ID to search accommodations around
     * @param priceFrom
     * @param priceTo
     * @param beachDistance Filter accommodations by maximum distance from the beach (in meters).
     * @param tags One or more accommodation tags (comma-separated).
     * @returns any Accommodation collection response (Deprecated)
     * @throws ApiError
     */
    public accommodationForListingAboOta(
        limit?: number,
        page: number = 1,
        adults?: number,
        amenity?: Array<
            | 'Unknown'
            | 'AMaximumOfTwoPetsAllowed'
            | 'ASteepStaircaseLeadsUpstairs'
            | 'AccessFromCorridor'
            | 'ActiveCard'
            | 'AdultFriendly'
            | 'AdventureParkNearby'
            | 'Aerobics'
            | 'AerobicsNearby'
            | 'AirConditioning'
            | 'AirPump'
            | 'Airport'
            | 'AirportNearby'
            | 'AirportTransfer'
            | 'AllInclusive'
            | 'AllianzCancellationInsurance'
            | 'AlpbachtalSeenlandCard'
            | 'AlpenthermeEhrenbergTicket2HoursDay'
            | 'AnimationPrograms'
            | 'Aquapark'
            | 'AquaparkNearby'
            | 'ArcadeGameRoom'
            | 'Archery'
            | 'AromaCabin'
            | 'AromaChamber'
            | 'ArrangementOfBeds'
            | 'ArrivalAfter20_00Oclock'
            | 'ArrivalAfterMidnight'
            | 'BabyBath'
            | 'BabyBathPlugProtector'
            | 'BabyBathTub'
            | 'BabyCot'
            | 'BabyCotAndHighChair'
            | 'BabyCotCanBePutIn'
            | 'BabyCotPayable'
            | 'BabyCotUpTo1_5Years'
            | 'BabyCotUpTo2Years'
            | 'BabyCotUpTo2YearsAndHighChair'
            | 'BabyCotUpTo3Years'
            | 'BabyFeedingSet'
            | 'BabyFoodAndDrink'
            | 'BabyFoodHeatingOption'
            | 'BabyPool'
            | 'BabySupervision'
            | 'BabySupervisorPhone'
            | 'BabyToys'
            | 'BadmintonNearby'
            | 'Balcony'
            | 'BalconyTerrace'
            | 'BallGames'
            | 'Bar'
            | 'BarByThePool'
            | 'BarNearby'
            | 'Barbecue'
            | 'BarrierFree'
            | 'BarrierFreeForWheelchairs'
            | 'BarrierFreeParking'
            | 'BarrierFreeRoom'
            | 'Basketball'
            | 'Bath'
            | 'BathNearby'
            | 'Bathrobe'
            | 'BathroomToiletries'
            | 'Bathtub'
            | 'BeachBar'
            | 'BeachFootball'
            | 'BeachTowel'
            | 'BeachTransfer'
            | 'BeachVolleyball'
            | 'BeautyParlour'
            | 'BedLinenIsNotProvided'
            | 'BedSheets'
            | 'BedSheetsAndTowels'
            | 'BedsReadyUponArrival'
            | 'Bicycle'
            | 'BicyclePathNearby'
            | 'BicycleTouringRouteNearby'
            | 'Bidet'
            | 'BigCapacityHouse'
            | 'BikeRental'
            | 'BikeRentalAtTheAccommodation'
            | 'BikeRentalNearTheAccommodation'
            | 'Billiard'
            | 'BilliardsAndTableTennis'
            | 'BioSauna'
            | 'BoatRental'
            | 'BoatRentalNearby'
            | 'Bobsled'
            | 'Books'
            | 'BoosterSeatForChildren'
            | 'BottledWater'
            | 'Bowling'
            | 'Breakfast'
            | 'BreakfastHotAndColdBuffet'
            | 'BreathingMonitor'
            | 'Buggy'
            | 'BungeeJumping'
            | 'BusAndTruckParkingLot'
            | 'BusStop'
            | 'BusStopNearby'
            | 'BusinessCenter'
            | 'CDDVDPlayer'
            | 'CDPlayer'
            | 'CableTV'
            | 'CableTVWithGermanAndScandinavianChannels'
            | 'CableTVWithGermanChannels'
            | 'CafNearby'
            | 'Cafe'
            | 'CarRental'
            | 'CarRentalNearby'
            | 'CarbonMonoxideDetector'
            | 'CashNotAccepted'
            | 'Casino'
            | 'CateringServices'
            | 'CateringServicesOptionA'
            | 'CateringServicesOptionB'
            | 'CateringServicesOptionC'
            | 'CateringServicesOptionD'
            | 'CateringServicesOptionE'
            | 'CeilingFan'
            | 'CentralHeating'
            | 'ChangingTable'
            | 'ChildAnimationPrograms'
            | 'ChildBedding'
            | 'ChildBike'
            | 'ChildMenu'
            | 'ChildSlide'
            | 'ChildStepUpStool'
            | 'ChildSupervision'
            | 'ChildrensBedUpTo12Years'
            | 'ChildrensBikeRental'
            | 'ChildrensClub'
            | 'ChildrensPool'
            | 'Chinese'
            | 'Cinema'
            | 'CinemaNearby'
            | 'CitySightseeingFlight'
            | 'Cleaning'
            | 'CleaningDuringStay'
            | 'CleaningOnlyOnWeekdays'
            | 'CleaningOnlyOnWeekends'
            | 'CleaningToolsProducts'
            | 'ClosestGroceryStore'
            | 'ClubCard'
            | 'ClubInnsbruckMemberCard'
            | 'CoffeeGrinder'
            | 'CoffeeMaker'
            | 'CoffeeTeaSet'
            | 'Computer'
            | 'ConferenceRoom'
            | 'ConnectorCover'
            | 'ConstructionNearby'
            | 'Cooker'
            | 'CookingInCauldron'
            | 'CookingOnGrillDisc'
            | 'Cookware'
            | 'CornerProtectorForFurnitures'
            | 'Couch'
            | 'Courtyard'
            | 'Cruise'
            | 'Curling'
            | 'CurlingFacilityNearby'
            | 'Curtain'
            | 'DVDPlayer'
            | 'DVDRental'
            | 'DVDRentalNearby'
            | 'DailyCleaning'
            | 'Darts'
            | 'DartsNearby'
            | 'DeckChair'
            | 'Dehumidifier'
            | 'DeskInTheRoom'
            | 'DialUpInternetAccess'
            | 'DietaryMenu'
            | 'DigitalTVService'
            | 'DirectAccessToSkiSlopes'
            | 'DirectSkiTrailAccess'
            | 'DisabledParking'
            | 'Disco'
            | 'DiscoNearby'
            | 'DiscoNearbyTheAccommodation'
            | 'Dishtowels'
            | 'Dishwasher'
            | 'Dryer'
            | 'DryingRack'
            | 'EgyptianCottonSheets'
            | 'ElectricCarChargingOption'
            | 'ElectricCarChargingStation'
            | 'ElectricCookerWithOven'
            | 'ElectricCookerWithSmallOven'
            | 'ElectricHeating'
            | 'ElectricHotPlate'
            | 'ElectricStove'
            | 'Electricity'
            | 'Elevator'
            | 'EnergyCost'
            | 'EnergySupply220V'
            | 'EnglishSpeakingStaff'
            | 'EnvironmentalTax'
            | 'EspressoMachine'
            | 'EventsAndPartiesAreNotPermitted'
            | 'ExchangeOffice'
            | 'ExchangeOfficeNearby'
            | 'ExpressCheckIn'
            | 'ExpressCheckOut'
            | 'ExternalEntranceToTheBedroom'
            | 'ExtraBed'
            | 'ExtraBeds'
            | 'ExtraFoldingBedsPayable'
            | 'ExtraRoomFor1PersonXROM'
            | 'ExtraRoomFor2Persons'
            | 'ExtraTowel'
            | 'FarmhouseStyleBuilding'
            | 'FencedProperty'
            | 'FerryPortTransfer'
            | 'Films'
            | 'FinalCleaning'
            | 'FinalCleaningAndBedSheetsInCaseOfAStayOfLessThan6Nights'
            | 'FinalCleaningIsNotIncludedInThePrice'
            | 'FinnishSauna'
            | 'FirePit'
            | 'Fireplace'
            | 'FirewoodCanBePurchased'
            | 'FirstAndSecondFloor'
            | 'FirstFloor'
            | 'FishPedicure'
            | 'Fishing'
            | 'FishingAtTheAccommodation'
            | 'FishingHouseStyleBuilding'
            | 'FishingNearTheAccommodation'
            | 'Fitness'
            | 'FoodBasket'
            | 'FoodDeliveryToTheAreaOnSpecifiedDays'
            | 'Football'
            | 'FreeDrivewayOnTheProperty'
            | 'FreeFirewood'
            | 'FreeGarageOnTheProperty'
            | 'FreeLocalPhoneCallsLimited'
            | 'FreeNewspapersInTheLobbyOnWeekdays'
            | 'FreeParking5MinutesAway'
            | 'FreeParkingNearby'
            | 'FreePrivateParking'
            | 'FreeSkiCoursesSkiRentalAndSkiTicketsForChildrenBornSince2009'
            | 'FreeSlideParkEntry'
            | 'FreeThermalSpaTicket'
            | 'FreeToiletries'
            | 'FreeTransferFromTrainStation'
            | 'FreeTransferToTrainStation'
            | 'FreeUsageOfLocalIndoorAndOutdoorPools'
            | 'FreeWiFiLimitedUse'
            | 'Freezer'
            | 'FreezerShelf'
            | 'French'
            | 'Fridge'
            | 'Games'
            | 'Garage'
            | 'Garage1x'
            | 'Garage1xUponRequest'
            | 'Garage2x'
            | 'GarageUponRequest'
            | 'Garden'
            | 'GardenFurniture'
            | 'Gas'
            | 'GasConvector'
            | 'GasHeating'
            | 'GasOrElectricStove'
            | 'GasPoweredFridge'
            | 'Gazebo'
            | 'GeothermalHeating'
            | 'Geyser'
            | 'GlutenFreeDiet'
            | 'GolfCourse'
            | 'GolfSimulator'
            | 'GolfSimulatorNearby'
            | 'GolfTeachingOnSite'
            | 'Griddle'
            | 'GrillingOptionPayable'
            | 'GroceryStore'
            | 'GroundFloor'
            | 'GuestCardCitiziensPassportCard'
            | 'GuestCardGC1'
            | 'GymSportHall'
            | 'GymSportHallNearby'
            | 'HDTV'
            | 'HOTELDETesztSzolg'
            | 'HairDryerOnRequestPayable'
            | 'HairdresserBeautySalon'
            | 'HairdresserBeautySalonNearby'
            | 'HairdressersParlour'
            | 'HairdressersWithFreeHaircut'
            | 'Hairdryer'
            | 'HalfBoard'
            | 'Handcart'
            | 'Hangers'
            | 'HaySauna'
            | 'HealthCenter'
            | 'HealthCenterNearby'
            | 'Heating'
            | 'HerbalSauna'
            | 'HighChair'
            | 'HighChairBabCotAndBabyBath'
            | 'Hiking'
            | 'HikingOpportunities'
            | 'HorseRiding'
            | 'HorseRidingAtTheAccommodation'
            | 'HorseRidingSchool15KmAway'
            | 'HorseRidingSchool5KmAway'
            | 'HotAirBalloon'
            | 'HotAirBalloonNearby'
            | 'HotPlate'
            | 'HotTub'
            | 'HotelAerobics'
            | 'HotelAerobicsNearby'
            | 'HotelBubbleBath'
            | 'HotelDarts'
            | 'HotelDisco'
            | 'HotelGardenNearby'
            | 'HotelHotTubNearby'
            | 'HotelHotelTransportation'
            | 'HouseMadeOfReinforcedConcrete'
            | 'HouseMadeOfWoodAndBrick'
            | 'HuluAccess'
            | 'Humidifier'
            | 'Hungarian'
            | 'Hunting'
            | 'HuntingNearTheAccommodation'
            | 'HurghadaElGounaOneWayTransfer'
            | 'HydroMassageShowerHead'
            | 'HypoallergenicBedding'
            | 'IPad'
            | 'IPodDockingStation'
            | 'IWouldLikeToReceiveInformationAboutAirportTransfer'
            | 'IWouldLikeToReceiveInformationAboutSkiPassDiscounts'
            | 'IWouldLikeToReceiveInformationAboutTheFoodBasket'
            | 'IceCave'
            | 'IceMaker'
            | 'IceSauna'
            | 'IceShower'
            | 'IceSkatingNearby'
            | 'InCaseOfAStayLongerThan6DaysTheFinalCleaningIsIncludedInThePrice'
            | 'InCaseOfAStayOfAtLeast6DaysTheFirstSetOfBedSheetsAndTowelsAreProvided'
            | 'Indian'
            | 'IndoorPaddlingPool'
            | 'IndoorPool'
            | 'IndoorPoolHeated'
            | 'IndoorPoolPayable'
            | 'IndoorSaltwaterPoolHeated'
            | 'IndoorSwimmingPoolNearby'
            | 'IndoorSwimmingPoolTicket'
            | 'IndoorTennisCourt'
            | 'IndoorTennisCourtNearby'
            | 'InformationServices'
            | 'InfraSauna'
            | 'InnsbruckCard'
            | 'InternetAccess'
            | 'InternetCaf'
            | 'InternetCafNearby'
            | 'InternetConnection'
            | 'InternetCorner'
            | 'InternetInPublicAreas'
            | 'IronAndIroningBoard'
            | 'IronAndIroningBoardOnRequest'
            | 'IronAndIroningBoardOnRequestPayable'
            | 'IroningAvailable'
            | 'IroningBoard'
            | 'ItCanBeRentedOnlyForVacation'
            | 'Italian'
            | 'Jacuzzi'
            | 'JacuzziBench'
            | 'JacuzziNearby'
            | 'JacuzziPayable'
            | 'JadeMassageBed'
            | 'JetPool'
            | 'KaiserwinklCard'
            | 'KaraokeEquipment'
            | 'Kettle'
            | 'KeyAcquisitionFee'
            | 'KeyAqusitionService'
            | 'KidsPoolHeated'
            | 'Kitchen'
            | 'KitchenUtensils'
            | 'KitchenWithColdWater'
            | 'KitchenWithHotAndColdWater'
            | 'KitchenWithWellWater'
            | 'Kitchenette'
            | 'KitchenetteWithHotAndColdWater'
            | 'KneippCircuit'
            | 'KosherFood'
            | 'LCDTV'
            | 'LEDTV'
            | 'LEGOLAND2DayTicketConsecutiveDays'
            | 'LEGOLANDBreakfast'
            | 'LactoseFreeDiet'
            | 'LateCheckIn20_00To08_00'
            | 'Laundry'
            | 'LaundryPayable'
            | 'LectureHall'
            | 'LeisurePool'
            | 'Library'
            | 'LimitedHotWater'
            | 'LimitedWiFiPayable'
            | 'LimousineOrCarRenting'
            | 'LimousineOrdering'
            | 'Lobby'
            | 'LobbyBarNearby'
            | 'LocalSpecialties'
            | 'LocalTax'
            | 'LocalTaxForChildren'
            | 'LocalTaxForChildren0To2Years'
            | 'LocalTaxForChildren12To15Years'
            | 'LocalTaxForChildren12To17'
            | 'LocalTaxForChildren3To11Years'
            | 'LocalTaxForChildren3To12Years'
            | 'LocalTaxForChildren3To17Years'
            | 'LocalTaxForChildren3To18Years'
            | 'LocalTaxForChildren3To5Years'
            | 'LocalTaxForChildren6To16Years'
            | 'LocatedNearAMainRoad'
            | 'LocatedOnDifferentLevels'
            | 'LockableCloset'
            | 'LongTermParkingPayable'
            | 'LowCarbDiet'
            | 'LowCeilingHeight'
            | 'LowCholesterolDiet'
            | 'LuggageRoom'
            | 'LuxPackage'
            | 'LyingMassage'
            | 'MP3Dock'
            | 'Manicure'
            | 'Massage'
            | 'MassageBench'
            | 'MassageInTheRoom'
            | 'MassageNearby'
            | 'MassageNozzle'
            | 'MassageSeats'
            | 'MedicalRoom'
            | 'MedicinalPool'
            | 'Mediterranean'
            | 'MemoryFoamMattress'
            | 'Mexican'
            | 'MicrowaveOven'
            | 'MiniBar'
            | 'MiniFridge'
            | 'Minigolf'
            | 'Minigrill'
            | 'Mixer'
            | 'MobileBabyCot'
            | 'MobileHome'
            | 'Modern'
            | 'MonkeyBars'
            | 'MotorboatRental'
            | 'MountainClimbing'
            | 'MountainClimbingNearby'
            | 'MudBath'
            | 'MultilingualStaff'
            | 'MurtalCard'
            | 'MushroomPicking'
            | 'MusicLibrary'
            | 'N10000LiterWaterTank'
            | 'N10PercentDiscountAtSportHervisSt_Anton'
            | 'N10PercentDiscountOnSwarovskiCrystalWorldsTickets'
            | 'N13KgWood'
            | 'N15KgWood'
            | 'N1SetOfBeachTowels'
            | 'N1UmbrellaAnd2SunbedsPerApartment'
            | 'N1XSaunaUsage'
            | 'N20000LiterWaterTank'
            | 'N20KgWood'
            | 'N24hHealthClub'
            | 'N24hPoolUse'
            | 'N2HoursOfSaunaUsage'
            | 'N2SetsOfWood'
            | 'N2XParkingSpace'
            | 'N2XWiFiAccess'
            | 'N30000LiterWaterTank'
            | 'N3FunctionGameTable'
            | 'N40000LiterWaterTank'
            | 'N50000LiterWaterTank'
            | 'N6DayAquaSpaPassAbove16Years'
            | 'N6DaySwimmingPoolTicketForChildren3To15Years'
            | 'NappyDryer'
            | 'NaturSauna'
            | 'NaturalArea'
            | 'NaturalGasHeating'
            | 'NearestRestaurant'
            | 'NeckShower'
            | 'Netflix'
            | 'NetflixAccess'
            | 'Newspaper'
            | 'NewspapersInTheLobbyPayable'
            | 'Nightclub'
            | 'NoBabyCot'
            | 'NoBedLinen'
            | 'NoCleaning'
            | 'NoDoorOnTheBedroom'
            | 'NoElevator'
            | 'NoHeating'
            | 'NoHotWater'
            | 'NoInsulationInTheHouse'
            | 'NoTowel'
            | 'NonDrinkingWater'
            | 'NonSmoking'
            | 'NonSmokingArea'
            | 'NotAvailableForSchools'
            | 'NotSuitableForYoungGroups'
            | 'NursingPillow'
            | 'OfficeRental'
            | 'Oil'
            | 'OilFueledPowerGenerator12V'
            | 'OilFueledPowerGenerator220V'
            | 'OilHeating'
            | 'OilRadiator'
            | 'OnSiteParking'
            | 'OnePersonSofa'
            | 'OneSkiPass'
            | 'OneTimeCleaningDuringStay'
            | 'OnlyDogsAllowed'
            | 'OnlyDogsAndCatsAllowed'
            | 'OnlyServiceAnimalsAllowed'
            | 'OnlyWomenAllowed'
            | 'OpenFireplaceAvailable'
            | 'OpenProperty'
            | 'OpeningBlockerForFenestration'
            | 'OpeningBlockerForFurniture'
            | 'OrganizedSightseeing'
            | 'OrganizedSightseeingNearby'
            | 'OrganizedTrip'
            | 'OrganizingCruises'
            | 'OrganizingCulturalAndSportingEvents'
            | 'OutdoorActivities'
            | 'OutdoorFireplace'
            | 'OutdoorFishCleaningPlace'
            | 'OutdoorPaddlingPool'
            | 'OutdoorPool'
            | 'OutdoorPoolHeated'
            | 'OutdoorPoolNearby'
            | 'OutdoorSauna'
            | 'OutdoorSeasonalPool'
            | 'OutdoorSeasonalPoolHeated'
            | 'OutdoorSlide'
            | 'OutdoorSwimmingPoolNearby'
            | 'OutdoorTennisCourt'
            | 'OutdoorTennisCourtNearby'
            | 'OutdoorWaterTank'
            | 'Oven'
            | 'OwnJacuzzi'
            | 'OwnPool'
            | 'OwnRestaurant'
            | 'PURIAPremiumSpaPE'
            | 'PaleoDiet'
            | 'PanoramicViewToTheLandscape'
            | 'PanoramicViewToTheMountains'
            | 'PanoramicViewToTheWaters'
            | 'PaperTowel'
            | 'Paragliding'
            | 'Park'
            | 'ParkNearby'
            | 'Parking'
            | 'ParkingInTheStreet'
            | 'ParkingNearby'
            | 'ParkingNearbyMustBeBookedInAdvance'
            | 'ParkingPlace'
            | 'ParkingService'
            | 'ParkingServicePayable'
            | 'ParkingSpaceCenterValClaretLavachet'
            | 'ParkingSpaceUponPriorRequest'
            | 'ParkingSpaceValThorensP0P1P25To7Nights'
            | 'PartiallyInsulated'
            | 'PastryShop'
            | 'PastryShopNearby'
            | 'Patio'
            | 'PayableParkingGarageNearby'
            | 'PedaloRental'
            | 'Pedicure'
            | 'PelletStove'
            | 'PetFriendly'
            | 'PetsAndServiceAnimalsNotAllowed'
            | 'PetsAreAllowed'
            | 'Phone'
            | 'PicnicArea'
            | 'Pizzeria'
            | 'PizzeriaNearby'
            | 'PlaneTicketReservation'
            | 'PlasmaTV'
            | 'PlayCarpet'
            | 'Playground'
            | 'PlaygroundNearby'
            | 'Playhouse'
            | 'Playpen'
            | 'Playroom'
            | 'PlumbingSystem'
            | 'PlungePool'
            | 'PlungeTub'
            | 'Pool'
            | 'PoolHeating'
            | 'PoolHeatingUponRequestNoLaterThan7DaysBeforeArrival'
            | 'PoolTicket'
            | 'Pools'
            | 'PoolsideCabanas'
            | 'PoolsideCabanasPayable'
            | 'Port'
            | 'PortableRadiator'
            | 'Potty'
            | 'PremiumTVChannels'
            | 'PrivateBathroomOutsideTheRoom'
            | 'PrivateBeach'
            | 'PrivateBikeStorage'
            | 'PrivateHotTub'
            | 'PrivateParkingPayable'
            | 'PrivatePier'
            | 'PrivateYachtMarina'
            | 'Pub'
            | 'PubNearby'
            | 'PublicPool'
            | 'Radio'
            | 'RadioAndCDPlayer'
            | 'Reception'
            | 'ReformDiet'
            | 'RefrigeratorOnRequest'
            | 'RegistrationFee'
            | 'RelaxRoom'
            | 'RentSpaAndRelaxArea'
            | 'Restroom'
            | 'RobinsonStyleAccommodation'
            | 'RoofGarden'
            | 'RoomAccommodationType'
            | 'RoomAmenityRoomAmenityWasherDryerTrue'
            | 'RoomAtAnotherAddress'
            | 'RoomBedSize'
            | 'RoomBedTypes'
            | 'RoomNumberOfBedrooms'
            | 'RoomNumberOfRooms'
            | 'RoomOutlook'
            | 'RoomRoomSize'
            | 'RoomSafe'
            | 'RoomSafeLaptopSize'
            | 'RoomScenicView'
            | 'RoomService'
            | 'RoomServiceLimitedHours'
            | 'RoseSauna'
            | 'Rowhouse'
            | 'RunningTrackNearby'
            | 'SAMOCompleteprogram'
            | 'SUPRental'
            | 'SafeDepositBox'
            | 'Sailing'
            | 'SailingNearby'
            | 'SaltCave'
            | 'SaltCaveNearby'
            | 'SaltChamber'
            | 'SaltTherapy'
            | 'SalzburgCard'
            | 'Sandpit'
            | 'SatelliteDish'
            | 'SatelliteDishWithGermanChannels'
            | 'SatelliteTV'
            | 'Sauna'
            | 'SaunaAndPoolTicket'
            | 'SaunaAndSteamBathWithBathrobe'
            | 'SaunaNearby'
            | 'SaunaSeance'
            | 'SaunaWithEssentialOils'
            | 'Saunas'
            | 'SchladmingSommercard'
            | 'ScubaDiving'
            | 'ScubaDivingNearby'
            | 'SecludedProperty'
            | 'SecondAndThirdBabyCot'
            | 'SecondBathroom'
            | 'SecondFloor'
            | 'SecondSetOfBedSheets'
            | 'SecretarialServices'
            | 'SecurityDeposit'
            | 'Seesaw'
            | 'SemiBasement'
            | 'SemiDetachedHouse'
            | 'SeparateBathroom'
            | 'SeparateBedroom'
            | 'SeparateDiningRoom'
            | 'SeparateEntrance'
            | 'SeparateLivingRoom'
            | 'SeparateWorkspaceForLaptops'
            | 'ServicePaketPackage'
            | 'Shampoo'
            | 'SharedBathroom'
            | 'SharedBathroomWithWashbasinInTheRoom'
            | 'SharedFridge'
            | 'SharedGardenFurniture'
            | 'SharedIndoorPool'
            | 'SharedKitchen'
            | 'SharedSauna'
            | 'SharedSaunaPayable'
            | 'SharedUseProperty'
            | 'SharedWashingMachinePayable'
            | 'ShipRental'
            | 'ShootingRange'
            | 'ShootingRangeNearby'
            | 'ShoppingCenter'
            | 'ShoppingCenterNearby'
            | 'ShoppingService'
            | 'Shower'
            | 'SilvrettaCard'
            | 'SkiLift'
            | 'SkiLiftNearby'
            | 'SkiPassAvailable'
            | 'SkiPassFor6Or13Days'
            | 'SkiRental'
            | 'SkiRentalDiscount10Percent'
            | 'SkiRentalDiscount10PercentSportHarryStGallenkirch'
            | 'SkiRentalDiscount20PercentSportBruggerSlden'
            | 'SkiRentalDiscount20PercentSportHuberKappl'
            | 'SkiRentalNearby'
            | 'SkiStorage'
            | 'SkiStorageNearby'
            | 'SkiTrailTransfer'
            | 'Skiing'
            | 'Skittles'
            | 'SleepNumberBedWithSelectComfortMattress'
            | 'Slide'
            | 'SlidePark'
            | 'Slippers'
            | 'SmallTiledStove'
            | 'SmartTV'
            | 'SmokingAndNonSmokingRoom'
            | 'SmokingArea'
            | 'SmokingRoom'
            | 'SnackBar'
            | 'SnackBarNearby'
            | 'Soap'
            | 'SolarEnergy12V'
            | 'SolarEnergy220V'
            | 'Solarium'
            | 'SolariumNearby'
            | 'Soundproofing'
            | 'SpaTreatments'
            | 'SpecialDietMenu'
            | 'Spices'
            | 'SportsEquipmentRental'
            | 'SportsEquipmentRentalNearby'
            | 'SportsField'
            | 'Squash'
            | 'StablingOfOwnHorseIsPossible'
            | 'SteamChamber'
            | 'SteamRoom'
            | 'SteamRoomNearby'
            | 'StereoSystem'
            | 'StoneHouse'
            | 'StreamCanal'
            | 'StreamingServices'
            | 'Stroller'
            | 'SunbathingTerrace'
            | 'Sunshade'
            | 'Surfing'
            | 'SurfingNearby'
            | 'SwimmingInNature'
            | 'SwimmingInNatureNearby'
            | 'SwimmingPool'
            | 'Swing'
            | 'SwingAndSandpit'
            | 'TV'
            | 'TVCRT'
            | 'TVRoom'
            | 'Table'
            | 'TableTennis'
            | 'Tablet'
            | 'TauernSpa10PercentDiscount'
            | 'Taxi'
            | 'TeaCoffeeMaker'
            | 'TeaInstantCoffee'
            | 'Telephone'
            | 'Television'
            | 'TelevisionPayable'
            | 'TempurPedicMattress'
            | 'Tennis'
            | 'Tepidarium'
            | 'TepidariumNearby'
            | 'Terrace'
            | 'Thai'
            | 'TheBedroomIsAWalkThroughRoom'
            | 'TheDepositIsASecurityRetainerAndWillBeRefundedUponProperReturnOfTheRentalProperty'
            | 'TheFeesRestrictionsDontApplyToServiceAnimals'
            | 'TheFirstSetOfSheets'
            | 'TheFirstSetOfSheetsAndTowels'
            | 'TheFirstSetOfTowels'
            | 'TheOwnerLivesInTheBuilding'
            | 'TheOwnerLivesOnTheProperty'
            | 'Theatre'
            | 'TheatreNearby'
            | 'ThermalBathNearby'
            | 'ThermalPool'
            | 'Thermometer'
            | 'ThirdFloor'
            | 'TileStove'
            | 'Toaster'
            | 'TobogganingNearby'
            | 'Toilet'
            | 'ToiletInTheYard'
            | 'ToiletPaper'
            | 'ToiletSeat'
            | 'ToiletWithHotAndColdWater'
            | 'ToiletWithoutWashbasin'
            | 'Toiletries'
            | 'TourGuiding'
            | 'TowelAndBedclothesPayable'
            | 'Towels'
            | 'Traditional'
            | 'TrainStation'
            | 'TrainStationNearby'
            | 'TramStop'
            | 'TramStopNearby'
            | 'Trampoline'
            | 'TranquilityRoom'
            | 'TransferFromTrainStationPayable'
            | 'TransferToTrainStationPayable'
            | 'TurkishBathHamam'
            | 'TwoPersonSofa'
            | 'UnderfloorHeating'
            | 'UnderfloorHeatingInPart'
            | 'UnderfloorHeatingInTheBathroom'
            | 'UnderfloorHeatingInTheEntireHouse'
            | 'UnlimitedUsageOfOutdoorPoolFor6Days'
            | 'UsableUpTo2YearsOfAgeMaximumOf3YearsOfAge'
            | 'VacuumCleaner'
            | 'VeganDiet'
            | 'VegetarianDiet'
            | 'VendingMachine'
            | 'Ventilator'
            | 'VideoGame'
            | 'VideoGameConsole'
            | 'VideoGamePayable'
            | 'VideoGames'
            | 'VideoLibrary'
            | 'ViewToTheLake'
            | 'ViewToTheLandscape'
            | 'ViewToTheMountains'
            | 'ViewToTheSea'
            | 'ViewToTheWatersAndMountains'
            | 'Vineyard'
            | 'Volleyball'
            | 'VolleyballFacilityNearby'
            | 'WaistMassage'
            | 'Washbasin'
            | 'WashingMachine'
            | 'WashingMachineAndDryer'
            | 'WasserparkRussbach'
            | 'Water'
            | 'WaterDispenser'
            | 'WaterMushroom'
            | 'WaterSki'
            | 'WaterSkiingNearby'
            | 'WaterSupplyFromWaterTank'
            | 'WaterfrontLocation'
            | 'WeeklyChangeOfBedSheetsAndTowels'
            | 'WeeklyCleaning'
            | 'WeeklyRoomCleaning'
            | 'WelcomePackage'
            | 'WellnessSectionRelaxation'
            | 'WellnessSpaNearby'
            | 'WellnessTowel'
            | 'Wheelchair'
            | 'WiFi'
            | 'WiFiInPublicAreas'
            | 'WiFiMaximumOf5Devices1GBWeek'
            | 'WineBar'
            | 'WineBarNearby'
            | 'WineCellar'
            | 'WineCellarNearby'
            | 'Winterized'
            | 'WiredInternetConnection'
            | 'Wood'
            | 'WoodFramedBuilding'
            | 'WoodenHouse'
            | 'XboxRoom'
            | 'Yoga'
            | 'Shading'
        >,
        amenityGroup?: Array<
            | 'Internet'
            | 'Parking'
            | 'Catering'
            | 'Tv'
            | 'SwimmingPool'
            | 'Sauna'
            | 'Playground'
            | 'Bicycle'
            | 'CardPayment'
            | 'Pets'
            | 'Jacuzzi'
            | 'AirConditioning'
        >,
        bookableOnline?: 0 | 1,
        bookingOptions?: Array<'RealTime' | 'FreeCancel' | 'WithoutPrepayment'>,
        category?: Array<
            | 'Unknown'
            | 'Apartment'
            | 'Chalet'
            | 'Guesthouse'
            | 'HolidayHome'
            | 'Hostel'
            | 'Hotel'
            | 'Inn'
            | 'Lighthouse'
            | 'Motel'
            | 'Pension'
            | 'Resort'
            | 'RuralTourism'
            | 'Sanatorium'
            | 'StudentHostel'
            | 'Villa'
        >,
        children?: number,
        childrenAge?: Array<number>,
        dateFrom?: string,
        dateTo?: string,
        onlyActive?: 0 | 1,
        provision?: Array<
            | 'Unknown'
            | 'NoMeal'
            | 'Breakfast'
            | 'HalfBoard'
            | 'FullBoard'
            | 'AllInclusive'
            | 'SoftAllInclusive'
            | 'Lunch'
            | 'Dinner'
        >,
        rating?: number,
        region?: number,
        voivodeship?: number,
        latitude?: number,
        longitude?: number,
        country?: number,
        radius?: number,
        order?: Array<string>,
        city?: number,
        nocCountry?: number,
        flexibleDays?: number,
        noPrice?: 0 | 1,
        cms?: string,
        cmsFieldPath?: string,
        cmsDocumentId?: string,
        poi?: string,
        priceFrom?: number,
        priceTo?: number,
        beachDistance?: number,
        tags?: Array<'kitchen' | 'private-bathroom'>,
    ): CancelablePromise<{
        'hydra:member': Array<Accommodation>;
        'hydra:totalItems'?: number;
        'hydra:view'?: {
            '@id'?: string;
            '@type'?: string;
            'hydra:first'?: string;
            'hydra:last'?: string;
            'hydra:previous'?: string;
            'hydra:next'?: string;
        };
        'hydra:search'?: {
            '@type'?: string;
            'hydra:template'?: string;
            'hydra:mapping'?: Array<{
                variable?: string;
                required?: boolean;
            }>;
        };
        'hydra:nopTotalItems'?: number;
        'hydra:realTimeItems'?: number;
        'hydra:partial'?: boolean;
        'hydra:strategy'?: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/accommodations/listing/abo-ota',
            query: {
                limit: limit,
                page: page,
                adults: adults,
                amenity: amenity,
                'amenity-group': amenityGroup,
                'bookable-online': bookableOnline,
                'booking-options': bookingOptions,
                category: category,
                children: children,
                'children-age': childrenAge,
                'date-from': dateFrom,
                'date-to': dateTo,
                'only-active': onlyActive,
                provision: provision,
                rating: rating,
                region: region,
                voivodeship: voivodeship,
                latitude: latitude,
                longitude: longitude,
                country: country,
                radius: radius,
                order: order,
                city: city,
                'noc-country': nocCountry,
                'flexible-days': flexibleDays,
                'no-price': noPrice,
                cms: cms,
                'cms-field-path': cmsFieldPath,
                'cms-document-id': cmsDocumentId,
                poi: poi,
                'price-from': priceFrom,
                'price-to': priceTo,
                beach_distance: beachDistance,
                tags: tags,
            },
            errors: {
                400: `Bad request`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
